/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EnumAuditLogType = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11;

export const EnumAuditLogType = {
    NUMBER_0: 0 as EnumAuditLogType,
    NUMBER_1: 1 as EnumAuditLogType,
    NUMBER_2: 2 as EnumAuditLogType,
    NUMBER_3: 3 as EnumAuditLogType,
    NUMBER_4: 4 as EnumAuditLogType,
    NUMBER_5: 5 as EnumAuditLogType,
    NUMBER_6: 6 as EnumAuditLogType,
    NUMBER_7: 7 as EnumAuditLogType,
    NUMBER_8: 8 as EnumAuditLogType,
    NUMBER_9: 9 as EnumAuditLogType,
    NUMBER_10: 10 as EnumAuditLogType,
    NUMBER_11: 11 as EnumAuditLogType
};

